/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_u1_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is a 1-minute typing test accurate?`)
};

const es_typing_u1_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es preciso un test de mecanografía de 1 minuto?`)
};

const de_typing_u1_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist ein 1-Minuten-Tipptest genau?`)
};

const nl_typing_u1_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is een typetest van 1 minuut nauwkeurig?`)
};

const fr_typing_u1_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un test de frappe d'1 minute est-il précis ?`)
};

const it_typing_u1_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il test di digitazione da 1 minuto è accurato?`)
};

const pt_br2_typing_u1_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um teste de digitação de 1 minuto é preciso?`)
};

const pt_typing_u1_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um teste de escrita de 1 minuto é preciso?`)
};

const ja_typing_u1_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1分間のタイピングテストは正確ですか？`)
};

const zh_typing_u1_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1分钟打字测试准确吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_u1_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_u1_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_u1_faq3_q", locale)
	if (locale === "en") return en_typing_u1_faq3_q(inputs)
	if (locale === "es") return es_typing_u1_faq3_q(inputs)
	if (locale === "de") return de_typing_u1_faq3_q(inputs)
	if (locale === "nl") return nl_typing_u1_faq3_q(inputs)
	if (locale === "fr") return fr_typing_u1_faq3_q(inputs)
	if (locale === "it") return it_typing_u1_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_typing_u1_faq3_q(inputs)
	if (locale === "pt") return pt_typing_u1_faq3_q(inputs)
	if (locale === "ja") return ja_typing_u1_faq3_q(inputs)
	return zh_typing_u1_faq3_q(inputs)
};